import React, { useState } from 'react'

import FilterIcon from 'public/images/icons/filter.svg'

import Button from 'components/button'
import FilterButton from 'components/filter/button'
import SvgSolidArrowChevronLeft from 'components/icon/solid/SolidArrowChevronLeft'
import ImageComponent from 'components/image'
import HitResultCounts from 'components/molecules/hit-result-counts'
import HitsSortBy from 'components/molecules/hits-sort-by'
import { HitsViewByType } from 'components/molecules/hits-view-by/constants'

import { useTranslate } from 'hooks'

import css from './filter-group-container.module.scss'

export type FilterGroupProps = {
  children: React.ReactNode
  viewBy: HitsViewByType
}

const FilterGroupContainer = ({ viewBy, children }: FilterGroupProps): JSX.Element => {
  const { t } = useTranslate('strapi-search-[...term]')
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  return (
    <section data-test-id="filter-group">
      <div className={css['container-desktop']} data-test-id="filter-group-container-desktop">
        {children}
      </div>
      <div className={css['container-mobile']}>
        <div className={css.mobileBtnGroup}>
          <div className={css.leftBtnGroup}>
            <HitResultCounts />
            <HitsSortBy viewBy={viewBy} />
          </div>

          <FilterButton
            icon={<FilterIcon />}
            className={css.filterPopButton}
            label={t('PageSearch.PageSearch_Filters_filter')}
            onClick={() => setIsMobileMenuOpen(true)}
          />
        </div>

        <div className={css.mobileMenu} style={{ display: isMobileMenuOpen ? 'block' : 'none' }}>
          <div className={css.mobileHeader}>
            <Button
              iconLeft={<SvgSolidArrowChevronLeft height="24px" width="24px" />}
              style="tertiary"
              className={css.btnBack}
              onClick={() => setIsMobileMenuOpen(false)}
              label={t('PageSearch.PageSearch_Filters_back')}
            />
            <div className={css.header}>{t('PageSearch.PageSearch_Filters_filter')}</div>
            <ImageComponent
              className={css.closeButton}
              src="/images/icons/mobile-close.svg"
              alt={''}
              width={24}
              height={24}
              onClick={() => setIsMobileMenuOpen(false)}
            />
          </div>
          <div className={css.filterGroup}>{children}</div>
        </div>
      </div>
    </section>
  )
}

export default FilterGroupContainer
